var exports = {
  "Q": "xa15a2ab7--aab5b4--content",
};

module.exports = exports;
